import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Subscription, interval, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TokenRefreshService {
    private refreshSub?: Subscription;

    // emit new tokens to whoever subscribes
    private tokenRefreshedSource = new Subject<any>();
    tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

    private refreshErrorSource = new Subject<any>();
    refreshError$ = this.refreshErrorSource.asObservable();

    constructor(private http: HttpClient) { }

    private refreshOktaToken(refreshToken: string) {
        const tokenEndpoint = environment.smsUrl[window.location.origin] + '/refreshtoken';
        const PgRefreshToken = localStorage.getItem('pg_refresh_token');
        const requestBody = { refresh_token: refreshToken, PgRefreshToken: PgRefreshToken };
        const httpOptions = { headers: { 'Content-Type': 'application/json' } };

        this.http.post(tokenEndpoint, requestBody, httpOptions).subscribe(
            (tokenResponse: any) => {
                this.tokenRefreshedSource.next(tokenResponse);
            },
            (error) => {
                this.refreshErrorSource.next(error);
            }
        );
    }

    scheduleTokenRefresh(refreshToken: string, expiresIn: number) {
        if (this.refreshSub) {
            this.refreshSub.unsubscribe();
        }
        const refreshInMs = (expiresIn - 300) * 1000; // before 5 minutes
        //const refreshInMs = 5 * 60 * 1000; // 5 minutes for testing
        this.refreshSub = interval(refreshInMs).subscribe(() => {
            this.refreshOktaToken(refreshToken);
        });
    }


    stopTokenRefresh() {
        if (this.refreshSub) {
            this.refreshSub.unsubscribe();
            this.refreshSub = undefined;
        }
    }
}
